import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const MediaPage = lazy(() =>
  import("@/admin/pages/MediaPage").then((m) => ({ default: m.MediaPage })),
);

export const Route = createFileRoute("/admin/media")({
  component: () => (
    <Suspense fallback={null}>
      <MediaPage />
    </Suspense>
  ),
});
